import React, {Component} from 'react';
import compose from '../../utils/compose'
import { hebMonthName, DatesSection, SearchByDates }  from '../../utils/calendarUtils';
import Calendar from './calendar'
import { AppDataParam} from '../../utils/constUtils'
import withNofeshService  from '../../hoc/withNofeshService.hoc';

class SearchFieldDates extends Component {

    state = { 
        open:false,
        searchFieldOK : false,
        searchFieldDates_placeholder: '',
        monthCalendarSection : DatesSection.MonthsSection,
        vacationSelectedCycleMonths:[],
        vacationSelectedCycleYear: null,
        startDay:null,
        endDay:null
    }


    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (prevProps.shouldClose === false && this.props.shouldClose === true)
        {
            this.setState({open:false}); 
        }
        return null;
    }
    

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { currentSearchObj }= this.props;
        if (prevProps.currentSearchObj !== currentSearchObj) {
            if (currentSearchObj) {

                this.setState(
                    { 
                        vacationSelectedCycleMonths: currentSearchObj.vacationSelectedCycleMonths,
                        vacationSelectedCycleYear: currentSearchObj.vacationSelectedCycleYear,
                        searchFieldDates_placeholder: currentSearchObj.searchFieldDates_placeholder

                    }); 
            }
        }
    }

    componentDidMount = () => {               

        
        console.log('SearchFieldDates componentDidMount currentSearchObj', this.props.currentSearchObj);
        const { vacationSelectedCycleMonths,
            vacationSelectedCycleYear, 
            searchFieldDates_placeholder,
            search_by_dates, 
            search_param_dates_range }= this.props.currentSearchObj;

        

        this.setState( 
            { 
                vacationSelectedCycleMonths: vacationSelectedCycleMonths,
                vacationSelectedCycleYear:vacationSelectedCycleYear,
                searchFieldDates_placeholder:searchFieldDates_placeholder,
                monthCalendarSection:search_by_dates
            });     

            if(search_by_dates == 2) {
                this.setState(
                {
                    startDay: search_param_dates_range.startDay,
                    endDay: search_param_dates_range.endDay
                });

            }
    }



    toggleOpenClose = () =>  {
        const open = !this.state.open;           
        this.setState({open:open});         
        let data = {};
        data.SearchFieldDatesOpened = open;
        this.props.updateOpenSearchFieldFn(data);
    }


    toggleMonth = (m) => {
        let mnth = m;
        mnth.selected = !m.selected;
        this.setState(prevState => ({
            vacationSelectedCycleMonths: prevState.vacationSelectedCycleMonths.map(
            obj => (obj.key === m.key ? Object.assign(obj, mnth) : obj)
          )
        }));
    }

    isMonthSelected = (m)  => {
        if (m.selected) {
            return true;
        }
        return false;
    }

    toggleMonthsSection = () => {
        this.setState({monthCalendarSection: DatesSection.MonthsSection}); 
        //1
    }

    toggleCalendarSection = () => {
        this.setState({monthCalendarSection: DatesSection.CalendarSection }); 
        //2
    }

    isMonthsSectionSelected = ()  => {


        if (this.state.monthCalendarSection == DatesSection.MonthsSection ) {
            return true;
        }
        return false;
    }

    isCalendarSectionSelected = ()  => {


        if (this.state.monthCalendarSection == DatesSection.CalendarSection ) {
            return true;
        }
        return false;
    }


    getDatesText = () =>  { 
        
        let s = 'מועדים';
        let addComa = false;
        
       if (this.state.monthCalendarSection == DatesSection.MonthsSection) {
                   
            this.state.vacationSelectedCycleMonths.forEach(function(month_t) {

                if (month_t.selected) {
                    if (addComa) {

                        console.log('getDatesText month_t', month_t)
                        s = s + ',' + hebMonthName(month_t.month);
                    } else {
                        addComa=true;
                        s = hebMonthName(month_t.month);
                    }
                }
            });

       } else {
           s = "בגבג נענענ";
       }

       if ( s.length > 28) {s = s.substring(0,27) + ' ...';}
       return s;
       
    }


  
    
    setOKDatesRange = () =>  { 

    }

    setOK = () =>  { 
        let datesMonths = this.getDatesText();
        this.setState({searchFieldDates_placeholder:datesMonths});
        this.setState({open:false});   
       
        let datesMonthsArr = [];
        this.state.vacationSelectedCycleMonths.forEach(function(month_t) {
                if (month_t.selected) {  datesMonthsArr.push(month_t)}
        });


        const data = { 
            search_param_dates_months: datesMonthsArr,
            searchFieldDates_placeholder: datesMonths,
            search_by_dates: SearchByDates.Months
        };
        this.props.setCurrentAppData(data, AppDataParam.set_app_data);
    }


    setOKCalendar = (startDay, endDay) =>  { 

        let datesRange = startDay + '-' + endDay;
        this.setState({searchFieldDates_placeholder:datesRange});      
        this.setState({open:false});   
       
        let range = { startDay: startDay, endDay: endDay};
        const data = { 
            search_param_dates_range: range,
            searchFieldDates_placeholder: datesRange,
            search_by_dates: SearchByDates.Range
        };
        this.props.setCurrentAppData(data, AppDataParam.set_app_data);
    }

    resetClear = () =>  {     
        this.setState({searchFieldDates_placeholder:''});          
        this.setState(prevState => ({
            vacationSelectedCycleMonths: prevState.vacationSelectedCycleMonths.map(
            obj  => {
                let t = {};
                Object.assign(t, obj);
                t.selected = false;
                Object.assign(obj, t); 
                return obj;
            }
          )
        }));


        this.props.setCurrentAppData(null, AppDataParam.reset_search_param_dates_months);
    }

    resetClearCalendar= () =>  {    
        this.setState({searchFieldDates_placeholder:''});      
        this.props.setCurrentAppData(null, AppDataParam.reset_search_param_dates_range);
    }


render() { 

    const { vacationSelectedCycleMonths, searchFieldDates_placeholder }= this.state;
      
    let months = null;
    if (vacationSelectedCycleMonths) {
         months = vacationSelectedCycleMonths.map((m,index) => {
            return (
                <div  key={m.key} onClick={() => this.toggleMonth(m)}
                    className={                    
                        this.isMonthSelected(m)
                        ? 'hp_search_field_dropDown_calendar_month  placeBox_selected' 
                        : 'hp_search_field_dropDown_calendar_month  placeBox_unselected' }>                                
                    <div className="hp_search_field_dropDown_inner_placeBox_check_wrapper">                                    
                        { (this.isMonthSelected(m)) ?
                            <img src={"./images/site/components/checked.png"} alt=""/>
                        : 
                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                        }
                    </div>
                    <div className="hp_search_field_dropDown_inner_DatesMonth_title">{hebMonthName(m.month)}</div>
                    <div className="hp_search_field_dropDown_inner_placeBox_title">{m.year}</div>
                </div>
            )
        });
    }

    let is_open = false;
    if (this.props.shouldClose) { is_open = false;   }        
    is_open = this.state.open;

    return (
        <React.Fragment>
            <div className="hp_search_field_container hp_search_field_marginRight15">

                    {(searchFieldDates_placeholder !== '')?
                    <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                    מועדים</span>  : null}
                   
                    <div className="hp_search_field_titleTest pointer" onClick={this.toggleOpenClose}>
                    {(searchFieldDates_placeholder == '')?
                        <span> מועדים </span>
                    : 
                    <span>{searchFieldDates_placeholder}</span>
                    }

                    <span className="open_arrow pointer" 
                        onClick={this.toggleOpenClose}></span>
                    </div>


                { (is_open) ?
                    <div className="hp_search_field_dropDown_containerDates" >
                        <div className="close_arrow pointer" onClick={this.toggleOpenClose}></div>
                        <div className="hp_search_field_dropDown_innerTitle">בחירת תאריכים</div>
                        <div className="cntered-flex calendarinnerTitle">
                            <div 
                                className={this.isMonthsSectionSelected()
                                ? 'calendarMonthsTitle  cntered-flex calendarSectionSelected' 
                                : 'calendarMonthsTitle  cntered-flex ' } 
                                onClick={this.toggleMonthsSection}>
                                חודשים שלמים
                            </div>
                            <div 
                                className={this.isCalendarSectionSelected()
                                ? 'calendarCalendarTitle  cntered-flex calendarSectionSelected' 
                                : 'calendarCalendarTitle  cntered-flex ' }
                                onClick={this.toggleCalendarSection}>
                                טווח תאריכים    
                            </div>
                        </div>

                        {(this.isMonthsSectionSelected()) ?
                            <React.Fragment>
                                <div className="hp_search_field_dropDown_inner_containerMonths">
                                    {months}
                                </div> 
                                
                                <div className="inline_block">
                                    <div className="hp_search_field_dropDown_inner_button_ok"
                                        onClick={this.setOK}>
                                        <div className="title">
                                            אישור
                                        </div>
                                    </div>

                                    <div className="hp_search_field_dropDown_inner_button_clear"
                                        onClick={this.resetClear}>
                                        נקה
                                    </div>
                                </div>
                            </React.Fragment>
                        : null }

                        {(this.isCalendarSectionSelected()) ?

                            <Calendar  
                                entitlementMonths={this.state.vacationSelectedCycleMonths}
                                currentMonth={1} 
                                currentYear={2026}  
                                startDay={this.state.startDay}
                                endDay={this.state.endDay}
                                setOKCalendar={this.setOKCalendar}
                                resetClearCalendar={this.resetClearCalendar}

                                />
                        : null }
                    </div>    
                    : null
                }
            </div>

            </React.Fragment>
    )
  }
}



  export default compose(
    withNofeshService()
  )(SearchFieldDates);